export type AgendaMengajarData = {
  pertemuan_ke: number;
  tanggal: string;
  uraian_materi: string;
  status_agenda: number;
  status_kaprodi: number;
  nama_lengkap: string;
  status_validasi_elearning: number;
  jenis_kelas: string;
  hadir: number | null;
  ijin: number | null;
  sakit: number | null;
  alpha: number | null;
};

export const fetchAgendaMengajar = async ({
  nip,
  kode_matkul,
  tahun,
  semester,
  kelas,
}: {
  nip: string;
  kode_matkul: string;
  tahun: string | number;
  semester: string | number;
  kelas: string;
}): Promise<AgendaMengajarData[]> => {
  // 1. Get token
  const formData = new FormData();
  formData.append(
    "username",
    import.meta.env.VITE_AKA_USERNAME || "remunerasi",
  );
  formData.append(
    "password",
    import.meta.env.VITE_AKA_PASSWORD || "kYtsgW4opasvxc#e#",
  );

  const tokenRes = await fetch("/api-aka/auth/token", {
    method: "POST",
    body: formData,
  });

  const tokenData = await tokenRes.json();
  const token = tokenData?.data;

  if (!token) {
    throw new Error("Failed to get authentication token");
  }

  // 2. Fetch agenda
  const agendaRes = await fetch(
    `/api-aka/remun/daftar-agenda-mengajar/${nip}/${kode_matkul}/${tahun}/${semester}/${kelas}`,
    {
      headers: {
        token: token,
        Accept: "application/json",
      },
    },
  );

  const agendaData = await agendaRes.json();
  return agendaData?.data || [];
};
